import { useEffect, useState } from 'react';
import { useAppSelector } from 'app/hooks';
import { Organization } from 'domains/orgDomain';
import orgService from 'services/orgService';

/**
 * Organization by id. Orgs the signed in user belongs to are already in the
 * store, but a job can belong to an org they are not a member of, and that one
 * has to be fetched before its configuration can be read.
 */
export const useOrgById = (orgId?: number) => {
  const orgs = useAppSelector((state) => state.org.list);
  const orgFromStore = orgs.find((item) => item.id === orgId);
  const [fetchedOrg, setFetchedOrg] = useState<Organization>();

  useEffect(() => {
    if (!orgId || orgFromStore) return;
    let canceled = false;
    orgService
      .getOrgById(orgId)
      .then((org) => {
        if (!canceled) setFetchedOrg(org);
      })
      .catch((error) => {
        console.error('Failed to load organization:', error);
      });
    return () => {
      canceled = true;
    };
  }, [orgId, orgFromStore]);

  if (orgFromStore) return orgFromStore;
  return fetchedOrg?.id === orgId ? fetchedOrg : undefined;
};
